export default "__VITE_ASSET__BccERLdZ__"